import { ReactKit } from '@team/react';
import { Layout as Root } from './layout';
import { Badge } from './components/badge';

export const Image = ReactKit.createCompoundComponent(Root, { Badge });

Image.displayName = 'Image';
Image.Badge.displayName = 'ImageBadge';
